export const FB = 'FB';
export const INTERNET = 'INTERNET';
export const LOYALTY = 'LOYALTY';
export const SUM = 'SUM';
export const DAILY = 'DAILY';
